import { AxiosResponse } from "axios";

import { Country } from "../../../store/countries/types";
import { apiPublicAxios } from "../../axios";

export const getCountries = (): Promise<AxiosResponse<Country[]>> =>
  apiPublicAxios.get(`/countries`);
